import { render, staticRenderFns } from "./insurance-amendment.vue?vue&type=template&id=36012a8f&scoped=true"
import script from "./insurance-amendment.vue?vue&type=script&lang=js"
export * from "./insurance-amendment.vue?vue&type=script&lang=js"
import style0 from "./insurance-amendment.vue?vue&type=style&index=0&id=36012a8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36012a8f",
  null
  
)

export default component.exports